import React from 'react';
import { latinAlphabet, url } from '../../../utils/variables';
import ImagePickerModal from '../../master/ImagePickerModal';
import { useTranslation } from 'react-i18next';
import ImageZoom from '../../master/ImageZoom';
import { useState } from 'react';
import Modal from '../../master/Modal';

export default function UploadCrashImages({ attachments, uploadDoc, changeStep , losses ,insuranceType}) {

    const crashImagesCul = attachments.filter(img => img.filename.includes('cul_crash_image'));
    const { t } = useTranslation();
    const [showImage , setShowImage] = useState(null);

    function renderButton(name, title) {
        const image = attachments.find(img => img.filename === name);
        return (
            <div className='upload-parent' style={image && {justifyContent: 'space-between'}}>
                {
                    image ?
                        <img src={`${url}/files?uid=${image.uid}&width=68&height=40`} alt='img'/> :
                        <div className='upload-icon-parent'>
                            <i className='far fa-image'/>
                        </div>
                }
                <div className='upload-text'>{title}</div>
            </div>
        )
    }

    return (
        <>
        <div className='complete-content'>
            <div className='box-wrapper'>
            <div className='title'>{t('Damaged positions and parts')} {t('Culprit')}</div>
            <div className='px20 py10'>
            {
                    crashImagesCul.map((img,i) => (
                        <div className='upload-parent space-between' key={img.id}>
                            
                            <div className='upload-text'>{`${t('Damaged positions and parts')} (${i+1})`}</div>
                            <img src={`${url}/files?uid=${img.uid}&width=150&height=150`} alt='img' onClick={()=> setShowImage(img.uid)}/>
                        </div>
                    ))
                }
                <ImagePickerModal
                        disableGallery
                        renderBtn={
                            renderButton('cul_crash_image',t('Add damaged accessories') )
                        }
                        upload={(image, done) => uploadDoc(image, `cul_crash_image${crashImagesCul.length + 1}`, done)}
                    />
            </div>
            </div>
            {insuranceType === 'third' && (
                <div>
                {losses.map((loss,index) =>(
                        <div  className='box-wrapper'>
                        <div className='title'>{`${t('Damaged positions and parts')} ${t('Losses')} ${t(latinAlphabet[index])}`}</div>
                        <div className='px20 py10'>
                            {
                                attachments.filter(img => img.filename.includes(`los_crash_image_x${index+1}x_`)).map((img,i) => (
                                    <div className='upload-parent space-between' key={img.id}>
                                        <div className='upload-text'>{`${t('Damaged positions and parts')} (${i+1})`}</div>
                                        <img src={`${url}/files?uid=${img.uid}&width=150&height=150`} alt='img' onClick={()=> setShowImage(img.uid)}/>
                                    </div>
                                )
                                    
                                )
                            }
                            <ImagePickerModal
                                disableGallery
                                renderBtn={
                                    renderButton('los_crash_image',t('Add damaged accessories'))
                                }
                                upload={(image, done) => {
                                    uploadDoc(image, `los_crash_image_x${index+1}x_${attachments.filter(img => img.filename.includes(`los_crash_image_x${index+1}x_`)).length + 1}`, done)
                                }}
                            />
                        </div>
                        </div>
                    )
                )}
            </div>
            )}
            
            <div className='nav-button-parent'>
                <button className='navButton mr5' onClick={() => changeStep(4)}>
                    {t('Next step')}
                    <i className='fas fa-chevron-down' />
                </button>
                <button className='navButton prev ml5' onClick={() => changeStep(2)}>
                    {t('Prev step')}
                    <i className='fas fa-chevron-up' />
                </button>
            </div>
            
        </div>
        <Modal visible={showImage}>
            <div className='image-modal'>
                <i className='fas fa-times'
                    onClick={() => setShowImage(null)}
                />
                <ImageZoom imgUid={showImage}/>
            </div>
        </Modal>
        </>
    );

}
